export const filtersTranslationEn = {
    search: "Search",
    reset: "Reset",
    selectAll: "All",
    selectNone: "None",
    clearFilters: "Clear filters",
};
